import './utils/tooltips'
import './utils/toggles'
import './utils/tabs'
import './utils/dropdowns'
// import './utils/darkmode'
import './utils/smooth-scroll'
import './utils/load-more'
import './utils/modal'
import './utils/popup'
import './utils/video'
import './utils/preview'
import './utils/steps'
import './utils/animate'
import './utils/search'
import './menu/menu-btns'
import './utils/gravity-form-inputs'
// import '../../includes/acf/lightning-builder/page-components/pc-post-listing/js/testimonials'
import '../../includes/acf/lightning-builder/page-components/pc-sticky-menu/js/sticky-menu'
import '../../includes/acf/lightning-builder/page-components/pc-post-listing/js/filters'
import '../../includes/acf/lightning-builder/page-components/pc-thumb-slider/js/thumb-slider'
import '../../includes/acf/lightning-builder/page-components/pc-gallery/js/gallery'
import '../../includes/acf/lightning-builder/page-components/pc-animate-numbers/js/animate-numbers'
// import '../../includes/acf/lightning-builder/page-components/pc-map/js/map'
import '../../includes/acf/lightning-builder/page-components/pc-products/js/product-slider'
import './woocommerce/woocommerce'
// css
import '../css/app.css'

if (module.hot) {
    module.hot.accept()
}
